<template>
  <!-- starting div -->
  <div
    id="page-content"
    class="customer-create-page"
    style="padding-bottom: 180px; margin-top: -10px"
  >
    <!-- section 1 :page title for customer update -->
    <GlobalHeader
    @redirectPage="redirectPage"
      :title="
        page == 'create'
          ? 'Add Bank or Credit Card'
          : 'Edit ' + (field.acc_type == 1 ? 'Bank' : 'Credit Card')
      "
    ></GlobalHeader>
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert
            class="alert-transparent alert-danger"
            :show="error_show && this.errors.any()"
          >
            <button
              type="button"
              @click="error_show = !error_show"
              class="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div
              v-for="item in errors.items"
              :key="item.id"
              v-if="item.scope == 'banking-form'"
            >
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <!-- section 2 : error validation block  -->
    <b-form
      class="mt-3"
      @submit.prevent="onSubmit('banking-form')"
      data-vv-scope="banking-form"
      style="margin-left: 3px; margin-right: 3px"
    >
      <b-row style="max-width: 750px">
        <b-col cols="8">
          <b-form-group
            v-if="page == 'create'"
            horizontal
            :label-cols="4"
            label="Account Type"
            label-for="acc_type"
            label-class="required"
          >
            <b-form-radio-group
              class="mt-2"
              v-validate="'required'"
              id="account_type"
              name="acc_type"
              data-vv-name="account type"
              v-model.trim="field.acc_type"
              :options="acc_types"
              @change="
                field = {
                  acc_type: $event,
                  acc_name: '',
                  acc_code: '',
                  currency: org_currency_id,
                  acc_number: '',
                  bank_name: '',
                  ifsc_code: '',
                  acc_desc: '',
                  is_primary: 0,
                }
              "
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label-cols="4"
            label="Account Name"
            label-for="acc_name"
            label-class="required"
          >
            <b-form-input
              v-validate="'required|max:100'"
              id="account_name"
              name="acc_name"
              data-vv-name="account name"
              v-model.trim="field.acc_name"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            horizontal
            :label-cols="4"
            label="Account Code"
            label-for="acc_code"
          >
            <b-form-input
              v-validate="'max:20'"
              id="account_code"
              name="acc_code"
              data-vv-name="account code"
              v-model.trim="field.acc_code"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            horizontal
            :label-cols="4"
            label="Currency"
            label-for="currency"
            label-class="required"
          >
            <v-select
              :clearable="false"
              v-validate="'required'"
              id="currency"
              name="currency"
              data-vv-name="currency"
              v-model.trim="field.currency"
              size="sm"
              index="currency_id"
              label="currency_name"
              :options="currency_list"
            />
          </b-form-group>
          <b-form-group
            v-if="field.acc_type == 1"
            horizontal
            :label-cols="4"
            label="Account Number"
            label-for="acc_number"
          >
            <b-form-input
              v-validate="'max:100'"
              id="account_number"
              name="acc_number"
              data-vv-name="account number"
              v-model.trim="field.acc_number"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            horizontal
            :label-cols="4"
            label="Bank Name"
            label-for="bank_name"
          >
            <b-form-input
              v-validate="'max:100'"
              id="bank_name"
              name="bank_name"
              data-vv-name="bank name"
              v-model.trim="field.bank_name"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="field.acc_type == 1"
            horizontal
            :label-cols="4"
            label="IFSC"
            label-for="ifsc_code"
          >
            <b-form-input
              v-validate="'max:11'"
              id="ifsc_code"
              name="ifsc_code"
              data-vv-name="IFSC"
              v-model.trim="field.ifsc_code"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            horizontal
            :label-cols="4"
            label="Description"
            label-for="acc_desc"
          >
            <b-form-textarea
              v-validate="'max:500'"
              id="acc_desc"
              name="acc_desc"
              data-vv-name="Description"
              v-model.trim="field.acc_desc"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            horizontal
            v-if="field.acc_type == 1"
            :label-cols="4"
            label=""
            label-for="acc_primary"
          >
            <b-form-checkbox
              v-if="page == 'create' || field.is_active == 1"
              v-model="field.is_primary"
              id="acc_primary"
              :unchecked-value="0"
              :value="1"
            >
              Make this primary
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="footer" style="box-shadow: 0 -4px 5px -3px #ccc">
        <div class="form-action" style="background: none !important">
          <b-button
            type="submit"
            size="sm"
            variant="primary"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i
            >Save
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import vSelect from "vue-select"; // vue seatch select component

export default {
  props: ["page", "submitted", "id"],
  name: "banking",
  components: { vSelect },
  data() {
    return {
      error_show: false,
      acc_types: [
        {
          text: "Bank",
          value: "1",
        },
        {
          text: "Credit Card",
          value: "2",
        },
      ],
      field: this.createFreshData(),
    };
  },
  methods: {
    redirectPage(){
      this.$router.push({name:'Banking'})
    },
    createFreshData() {
      return {
        acc_type: 1,
        acc_name: "",
        acc_code: "",
        currency: "",
        acc_number: "",
        bank_name: "",
        ifsc_code: "",
        acc_desc: "",
        is_primary: 0,
      };
    },
    onSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.$emit("onSubmit", {
            data: this.field,
          });
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fai
        }
      });
    },
  },
  created() {
    if (this.page == "update") {
      this.field = this.list;
    } else {
      this.field.currency = this.org_currency_id;
    }
  },
  computed: {
    ...mapGetters(["org_currency_id"]),
    ...mapState({
      currency_list: (state) => state.banking.currency_list,
      list: (state) => state.banking.list,
    }),
  },
};
</script>
